<app-header />
@if (showLive()) {
  <app-live-marquee />
}
<main class="pb-[105px] relative z-1 md:pb-[200px] overflow-hidden">
  <router-outlet />
  <app-navigation />
</main>

@if (showFirstDepositBanner()) {
  <div
    class="fixed inset-0 z-[200] flex items-center justify-center px-4 bg-[rgba(25,27,33,0.77)] backdrop-blur-[14.8px]"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="firstDepositBannerText()"
    (click)="dismissFirstDepositBanner($event)">
    <div
      role="button"
      tabindex="0"
      class="relative block aspect-[324/336] w-[clamp(324px,calc(100vw-32px),380px)] rounded-[10px] bg-cover bg-center bg-no-repeat text-left shadow-[0_0_18px_rgba(47,127,254,0.25)]"
      [style.background-image]="'url(' + firstDepositBannerImageUrl() + ')'"
      (click)="openFirstDepositBanner($event)"
      (keydown.enter)="openFirstDepositBanner($event)">
      <button
        type="button"
        class="absolute flex items-center justify-center rounded-full border border-[#FFE467]/80 bg-[radial-gradient(81.92%_110.11%_at_50%_-10%,#FFF06A_0%,#FFA72A_52%,#EA6415_100%)] text-[clamp(14px,4.3vw,16px)] font-black uppercase leading-none text-white shadow-[0_0_10px_rgba(255,170,32,0.95),inset_0_1px_1px_rgba(255,255,255,0.45)] active:scale-[0.98]"
        style="left: 21.6049%; top: 81.5476%; width: 56.7901%; height: 11.0119%"
        (click)="openFirstDepositBanner($event)">
        Забрать бонус
      </button>

      <button
        type="button"
        aria-label="Закрыть баннер"
        class="absolute -right-[13px] -top-[13px] flex size-[50px] items-center justify-center rounded-full border border-white/35 bg-[#2A1931]/45 shadow-[0_4px_16px_rgba(0,0,0,0.25)] backdrop-blur-[18px] [-webkit-backdrop-filter:blur(18px)]"
        (click)="dismissFirstDepositBanner($event)">
        <span class="absolute h-[1.5px] w-8 rotate-45 rounded-full bg-white"></span>
        <span class="absolute h-[1.5px] w-8 -rotate-45 rounded-full bg-white"></span>
      </button>
    </div>
  </div>
}

@if (showExternalBalanceModal()) {
  <div
    class="fixed inset-0 z-[200] flex items-center justify-center px-4 bg-[rgba(25,27,33,0.77)] backdrop-blur-[14.8px]"
    role="dialog"
    aria-modal="true"
    (click)="closeExternalBalanceModal()">
    <div
      class="w-full max-w-[320px] rounded-[24px] bg-transparent px-5 pb-5 pt-7 text-center"
      (click)="$event.stopPropagation()">
      <p class="text-[16px] font-black leading-6 text-white">⚠️ ВАЖНО!</p>

      <p class="mt-5 text-[16px] font-black leading-6 text-white">
        Звёзды частично перенесены с баланса &#64;patrickstarsrobot!
      </p>
      <p class="mt-4 text-[16px] font-black leading-6 text-white">
        Если ты будешь открывать кейсы или играть в мини-игры, то звёзды будут списываться с баланса &#64;patrickstarsrobot!
      </p>
      <p class="mt-4 text-[16px] font-black leading-6 text-white">
        Но при этом, звёзды, заработанные в кейсах и мини-играх НЕ будут перенесены на баланс &#64;patrickstarsrobot!
      </p>

      <button
        type="button"
        class="mt-6 h-14 w-full rounded-[28px] border border-[#3E9EFF] bg-[#2F7FFE] text-2xl font-semibold leading-none text-white transition hover:brightness-110"
        (click)="closeExternalBalanceModal()">
        Ок
      </button>
    </div>
  </div>
}

<hlm-toaster [richColors]="true" />
